import React, {useCallback} from 'react';
import css from "../Profile.module.scss";
import placeholder from '../../../../images/yacht_placeholder.png'
import dots from "../../../../images/submenu.svg";
import share from "../../../../images/submenu_share.svg";
import item3 from "../../../../images/edit.svg";
import item4 from "../../../../images/trash.svg";
import {useTheme} from "../../../../App";
import {useTranslation} from "react-i18next";

const Yacht = ({item, setEditYacht, setDeleteYacht, isDark}) => {
  const {t} = useTranslation()
  return (
    <div className={`${css.license} ${css.yacht} ${isDark && css.yacht__dark}`}>
      <img src={item.image ? `data:image/png;base64,${item.image}` : placeholder} className={css.yacht__img} alt=""/>
      <div className={css.license__add}>
        <button className={'submenuTrig'}>
          <img src={dots} alt=""/>
        </button>
        <div className={`submenu ${css.license__submenu} ${isDark && 'submenu__dark'}`}>
          <button onClick={() => setEditYacht(item)} className={'submenuItem'}>
            <img src={item3} alt="" className={'submenuIcon'}/>
            {t('edit')}
          </button>
          <button onClick={() => setDeleteYacht(item)} className={'submenuItem'}>
            <img src={item4} alt="" className={'submenuIcon'}/>
            {t('delete')}
          </button>
        </div>
      </div>
      <div className={css.license__info}>
        <p className={css.name}>{item.yacht.name}</p>
        <div className={css.info__data}>
          <div className={css.info__col}>
            <p className={css.info__value}>{item.yacht.yacht_model?.name}{item.yacht.year ? `, ${item.yacht.year}` : ''}</p>
            {item.yacht.operator !== undefined && <div className={css.info__col}>
              <p className={css.info__label}>{t('operator')}:</p>
              <p className={`${css.info__value} m-0`}>{item.yacht.operator?.name}</p>
            </div>}
            {item.yacht.yacht_owner_name !== undefined && <div className={css.info__col}>
              <p className={css.info__label}>{t('yachtOwner')}:</p>
              <p className={`${css.info__value} m-0`}>{item.yacht.yacht_owner_name}</p>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Yacht);
